//---- components ---------
//---- mixins -------------
//---- services -----------
import { ajaxService } from '@/app/services';
import KMOfflineService from "@/app/services/kmoffline.service.js";
//---- other --------------
import URL from '../common/URL.js';
//---- 3rd-parties --------

class DraftService {

    getDraftCases() {
        if (KMOfflineService.isReplica())
            return null;
        return ajaxService.get(URL.getAllDraftsCasesUrl)
    }

    deleteDraftCase(params) {
        if (KMOfflineService.isReplica())
            return null;
        return ajaxService.postData(URL.deleteDraftCaseUrl, params)
    }
    
    viewDraftCase(params) {
        if (KMOfflineService.isReplica())
            return null;
        return ajaxService.postData(URL.viewDraftsUrl, params)
    }

    loadDraft() {
        if (KMOfflineService.isReplica())
            return null;
        return ajaxService.get(URL.loadDraftsUrl)
    }

    restoreDraftForExistingCase(params) {
        if (KMOfflineService.isReplica())
            return null;
        return ajaxService.postData(URL.restoreExistingCaseUrl, params)
    }

    discardDraftForExistingCase(params) {
        if (KMOfflineService.isReplica())
            return null;
        return ajaxService.postData(URL.discardDraftCaseUrl, params)
    }

    restoreDraftForNewCase(params) {
        if (KMOfflineService.isReplica())
            return null;
        return ajaxService.postData(URL.restoreNewCaseUrl, params)
    }
}

export default new DraftService();